import { render, staticRenderFns } from "./block-post-button.vue?vue&type=template&id=6f624cc0&"
import script from "./block-post-button.vue?vue&type=script&lang=js&"
export * from "./block-post-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports